import React from 'react';
import PropTypes from 'prop-types';
import OverviewTable from '../../../components/Table/OverviewTable';
import localization from '../../../i18n/localization';

const columnDefinition = [
  { id: 'actions', label: localization.de.shop.itemValidityTable.ACTIONS },
  { id: 'id', label: localization.de.shop.itemValidityTable.ID },
  { id: 'title', label: localization.de.shop.itemValidityTable.TITLE },
  { id: 'startDate', label: localization.de.shop.itemValidityTable.START_DATE },
  { id: 'endDate', label: localization.de.shop.itemValidityTable.END_DATE },
  {
    id: 'selectableStartDate',
    label: localization.de.shop.itemValidityTable.SELECTABLE_START_DATE,
  },
  {
    id: 'selectableEndDate',
    label: localization.de.shop.itemValidityTable.SELECTABLE_END_DATE,
  },
];

export default function ItemValidityTable({ itemValidities, onRowDelete }) {
  return (
    <OverviewTable
      columnDefinition={columnDefinition}
      data={itemValidities}
      onRowDelete={onRowDelete}
    />
  );
}

ItemValidityTable.propTypes = {
  itemValidities: PropTypes.array,
  onRowDelete: PropTypes.func,
};
ItemValidityTable.defaultProps = {
  data: [],
};



// WEBPACK FOOTER //
// ./src/views/shop/components/ItemValidityTable.jsx